export class RepairModel {

  uid: number;
  observedDateTime: string;
  ref: string;
  loggedByUser: string

  notes: string;
  concatRepairNames: string;

  assetTypeUid: number;
  assetName: string;
  repairs: string;

  jobUid: number;
  jobId: string;
  assetTypeIcon: string;
  observationRef: string;
  
  constructor() {

  }
}